import { Box, Button, Group, MultiSelect, Text } from '@mantine/core';
import { useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { useCreateCustomMasterFund } from '../../../../../../../services/jurisdiction.service';
import toast from 'react-hot-toast';
import { extractApiError } from '../../../../../../../utils';

export const CustomMultiSelect = ({ periodId, workflowId, onSelectCustomMasterFund, ...props }) => {
  const [searchValue, setSearchValue] = useState('');

  const createMasterFund = useCreateCustomMasterFund({ periodId, workflowId });

  const handleCreateNewMasterFund = e => {
    e?.preventDefault();
    e?.stopPropagation();

    createMasterFund.mutate(
      {
        fund_name: searchValue
      },
      {
        onSuccess: res => {
          setSearchValue('');
          onSelectCustomMasterFund(res);
        },
        onError: err => {
          toast.error(extractApiError(err, 'Unable to create this custom master fund.'));
        }
      }
    );
  };

  const renderMultiSelectOption = ({ option }) => {
    if (option.add_option)
      return (
        <Box w="100%" display="flex" h={32}>
          <Button
            size="xs"
            h={32}
            disabled={!searchValue || createMasterFund.isLoading}
            variant="transparent"
            onClick={handleCreateNewMasterFund}
            leftSection={<BsPlus size={16} />}
            loading={createMasterFund.isLoading}
          >
            Add New Fund
          </Button>
        </Box>
      );

    return (
      <Group gap="sm">
        <Text size="sm">{option.label}</Text>
      </Group>
    );
  };
  return (
    <MultiSelect
      {...props}
      required={props.required}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      renderOption={renderMultiSelectOption}
      hidePickedOptions
      nothingFoundMessage={
        <Box w="100%" display="flex" px={9.5}>
          <Button
            size="xs"
            p={0}
            h={32}
            variant="transparent"
            leftSection={<BsPlus size={16} />}
            disabled={!searchValue || createMasterFund.isLoading}
            loading={createMasterFund.isLoading}
            onClick={handleCreateNewMasterFund}
          >
            Add New Fund
          </Button>
        </Box>
      }
    />
  );
};
